<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row v-for="day in days" :key="day.value">
          <b-col cols="12" md="2">
            <b-form-checkbox v-model="itemData.disable_schedule[day.value]" class="mb-2">
              {{ day.label }}
            </b-form-checkbox>
          </b-col>
          <template v-if="itemData.disable_schedule[day.value]">
            <b-col cols="12" md="5">
              <validation-provider
                #default="validationContext"
                :name="`${day.value}_start_time`"
                rules="required"
              >
                <b-form-group
                  label="Start Time"
                  :label-for="`${day.value}_start_time`"
                  class="mb-2"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-timepicker
                    :id="`${day.value}_start_time`"
                    v-model="itemData.disable_schedule[`${day.value}_start`]"
                    placeholder="Choose start time"
                    :hour12="false"
                    :minutes-step="15"
                    @input="() => validateDayTimes(day.value)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="5">
              <validation-provider
                #default="validationContext"
                :name="`${day.value}_end_time`"
                rules="required"
              >
                <b-form-group
                  label="End Time"
                  :label-for="`${day.value}_end_time`"
                  class="mb-2"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-timepicker
                    :id="`${day.value}_end_time`"
                    v-model="itemData.disable_schedule[`${day.value}_end`]"
                    placeholder="Choose end time"
                    :hour12="false"
                    :minutes-step="15"
                    @input="() => validateDayTimes(day.value)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </template>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';
import { ref, watch } from '@vue/composition-api';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    propItemData: {
      type: Object,
      required: true
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();

    const days = [
      { label: 'Monday', value: 'monday' },
      { label: 'Tuesday', value: 'tuesday' },
      { label: 'Wednesday', value: 'wednesday' },
      { label: 'Thursday', value: 'thursday' },
      { label: 'Friday', value: 'friday' },
      { label: 'Saturday', value: 'saturday' },
      { label: 'Sunday', value: 'sunday' }
    ];

    // function normalizeSchedule(rawSchedule) {
    //   const result = {};
    //   days.forEach(day => {
    //     const val = rawSchedule?.[day.value];
    //     if (
    //       Array.isArray(val) &&
    //       val.length > 0 &&
    //       Array.isArray(val[0]) &&
    //       val[0].length === 2 &&
    //       typeof val[0][0] === 'string' &&
    //       typeof val[0][1] === 'string'
    //     ) {
    //       // Handles [["00:00:00", "01:00:00"]]
    //       result[day.value] = true;
    //       result[`${day.value}_start`] = val[0][0].slice(0, 5); // "hh:mm"
    //       result[`${day.value}_end`] = val[0][1].slice(0, 5);   // "hh:mm"
    //     } else {
    //       result[day.value] = false;
    //       result[`${day.value}_start`] = "00:00";
    //       result[`${day.value}_end`] = "00:00";
    //     }
    //   });
    //   return result;
    // }

    const itemData = ref({
      ...JSON.parse(JSON.stringify(props.propItemData))
    });

    // itemData.value.disable_schedule = normalizeSchedule(props.propItemData?.disable_schedule || {});

    const validateDayTimes = (day) => {
      if (!itemData.value.disable_schedule[day]) return;

      const startTime = itemData.value.disable_schedule[`${day}_start`];
      const endTime = itemData.value.disable_schedule[`${day}_end`];

      if (startTime && endTime) {
        const start = new Date(`2000-01-01T${startTime}`);
        const end = new Date(`2000-01-01T${endTime}`);

        if (end <= start) {
          // If end time is not after start time, set it to 1 hour after start
          const newEnd = new Date(start.getTime() + 60 * 60 * 1000);
          itemData.value.disable_schedule[`${day}_end`] = newEnd.toTimeString().slice(0, 5);
        }
        // New: If start and end are the same, set a validation error
        if (startTime === endTime) {
          itemData.value[`_${day}_end_error`] = 'End time must be different from start time.';
        } else {
          itemData.value[`_${day}_end_error`] = '';
        }
      }
    };

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Form observer reference is null");
        return false;
      }

      const validation = await refFormObserver.value.validate();
      return validation;
    };

    const setupWatcher = (key) => {
      watch(
        () => itemData.value.disable_schedule[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:item-data", { disable_schedule: { ...itemData.value.disable_schedule } });
          }
        }
      );
    };

    days.forEach(day => {
      setupWatcher(day.value);
      setupWatcher(`${day.value}_start`);
      setupWatcher(`${day.value}_end`);
    });

    return {
      refFormObserver,
      getValidationState,
      itemData,
      validateStep,
      validateDayTimes,
      days,
      // Expose error fields for template
      ...days.reduce((acc, day) => {
        acc[`_${day.value}_end_error`] = ref('');
        return acc;
      }, {})
    }
  }
}
</script>
